export const FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER = 'FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER';
export const UPLOAD_DC_APP_PARENT_MAPPING_BY_PARTNER = 'UPLOAD_DC_APP_PARENT_MAPPING_BY_PARTNER';
export const CLEAR_UPLOAD_DC_APP_PARENT_MAPPING_RESULT =
  'CLEAR_UPLOAD_DC_APP_PARENT_MAPPING_RESULT';
